import { createContext } from "react";
import { IContext } from "./collect.types";

export const Context = createContext<IContext | undefined>(undefined);
